import { t } from 'i18next';
import { NewForm } from '../../../../../types/apiResponse/form';
import { getRequiredFormFieldsNotInForm } from './utils';

export const validateForm = (formData: NewForm) => {
  if (formData.description.length <= 0) {
    throw new Error(t('descriptionIsRequired'));
  }

  if (formData.fields.length <= 0) {
    throw new Error(t('atLeastOneFieldIsRequired'));
  }

  if (new Date(formData.initialDate) >= new Date(formData.finalDate)) {
    throw new Error(t('finalDateMustBeGreaterThanInitialDate'));
  }

  if (getRequiredFormFieldsNotInForm(formData).length > 0) {
    throw new Error(t('requiredFieldsNotFilled'));
  }
};
